import { apiBaseUrl } from '../../lib/api';
import { cn } from '../../lib/cn';

/** Iniciales sobre el gradiente de marca cuando no hay foto. */
export function Avatar({
  name,
  email,
  src,
  size = 'md',
  className,
}: {
  name?: string | null;
  email?: string;
  src?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const dimension = {
    sm: 'h-7 w-7 text-[11px]',
    md: 'h-9 w-9 text-xs',
    lg: 'h-14 w-14 text-lg',
  }[size];

  const etiqueta = name?.trim() || email || '';
  const iniciales =
    etiqueta
      .split(/[\s@.]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((parte) => parte[0]?.toUpperCase())
      .join('') || '?';

  if (src) {
    /*
     * La API devuelve una ruta (`/api/users/…/avatar`), no una dirección
     * completa: la clave del objeto en R2 no debe salir nunca y una URL firmada
     * caduca, así que guardarla en el estado del cliente sería un avatar roto a
     * los pocos minutos. Aquí se resuelve contra el origen de la API, que en el
     * despliegue real es otro dominio.
     *
     * Va sin `crossOrigin`: una imagen normal no pasa por CORS, y la cookie de
     * sesión viaja porque es `SameSite=None` en el despliegue entre dominios.
     */
    const direccion = src.startsWith('/') ? new URL(src, apiBaseUrl()).toString() : src;

    return (
      <img
        src={direccion}
        alt={etiqueta}
        className={cn('rounded-full object-cover', dimension, className)}
        // Sin foto —o sin permiso para verla— el endpoint responde 404: el
        // hueco roto se sustituye por las iniciales de siempre.
        onError={(event) => {
          event.currentTarget.style.display = 'none';
        }}
      />
    );
  }

  return (
    <span
      className={cn(
        'grid shrink-0 place-items-center rounded-full bg-brand font-semibold text-background',
        dimension,
        className,
      )}
      aria-hidden="true"
    >
      {iniciales}
    </span>
  );
}
